import { FaBalanceScale } from "react-icons/fa";

export default function BrandMark({ className = "", compact = false }) {
  const sizeClass = compact ? "h-9 w-9 sm:h-11 sm:w-11" : "h-12 w-12";

  return (
    <span
      className={`inline-flex ${sizeClass} shrink-0 items-center justify-center rounded-full border border-amber-950/10 bg-[linear-gradient(180deg,#fff8eb_0%,#f2dfb7_100%)] p-[2px] shadow-[0_14px_30px_rgba(15,23,42,0.12)] ${className}`}
      aria-hidden="true"
    >
      <span className="relative flex h-full w-full items-center justify-center rounded-full border border-white/70 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.98)_0%,_rgba(252,248,240,0.94)_48%,_rgba(242,230,207,0.96)_100%)]">
        <span className="absolute inset-[7px] rounded-full border border-amber-200/60" />
        <FaBalanceScale className="relative z-10 text-sm text-amber-800/90 sm:text-lg" />
        <span className="sr-only">Cleisson Oliveira Advocacia</span>
      </span>
    </span>
  );
}
